import { render, staticRenderFns } from "./TheTranscriptStudent.vue?vue&type=template&id=6af38478&scoped=true&"
import script from "./TheTranscriptStudent.vue?vue&type=script&lang=js&"
export * from "./TheTranscriptStudent.vue?vue&type=script&lang=js&"
import style0 from "./TheTranscriptStudent.vue?vue&type=style&index=0&id=6af38478&prod&lang=less&scoped=true&"
import style1 from "./TheTranscriptStudent.vue?vue&type=style&index=1&id=6af38478&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af38478",
  null
  
)

export default component.exports